import React from 'react'

export const formatPercentageAmount = (amount: number) => `${Math.floor(amount * 100)}%`

export const FormattedPercentage: React.SFC<{ amount: number }> = ({ amount }) => (
  <>{formatPercentageAmount(amount)}</>
)
